import { Text } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'

interface Props {
  shopName: string
}

const SellerLabel = (props: Props) => {
  const { shopName } = props

  return (
    <S.Wrapper>
      <Text size="kilo" noMargin>
        Vendido e entregue por
      </Text>
      <Text size="kilo" noMargin isBold>
        {' '}
        {shopName}
      </Text>
    </S.Wrapper>
  )
}

export default SellerLabel
